<template>
    <div class="payment-page">

        <app-loading
            v-if="loading"
        />

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :is_back="false"
            :background="'transparent'"
            @clickMenu="clickMenu"
        />

        <div class="payment-page__container">
            <div class="payment-page__date">
                {{ day }} {{ monthName }} в {{ selectTime }}
            </div>

            <div class="payment-page__time-action">
                Время действия брони {{bookingTime / 60}} минут
            </div>


            <div class="payment-page__descr-wrapper" style="margin-top: 43px">

              <div class="payment-page__descr">
                <div class="payment-page__descr-title">
                  Анимации:

                  <div class="payment-page__descr-subtitle">
                    С учетом рейтинга
                  </div>

                </div>

                <div class="payment-page__descr-price">
                  {{ defaultPrice }} + {{ priceVideo.coef }} = {{ priceVideo.value }} ₽
                </div>

              </div>

            </div>

            <div class="payment-page__descr-wrapper">
                <div class="payment-page__descr">
                    <div class="payment-page__descr-title">
                        Длительность:

                        <div class="payment-page__descr-subtitle">
                            {{ duration }}
                        </div>

                    </div>

                    <div class="payment-page__descr-price">
                         {{ priceVideo.value }} х {{ getPriceDuration.coef }} = {{ getPriceDuration.value }} ₽
                    </div>
                    
                </div>
            </div>

            <div class="payment-page__descr-wrapper">
                <div class="payment-page__descr">
                    <div class="payment-page__descr-title">
                        Тема:

                        <div class="payment-page__descr-subtitle">
                            {{ theme.text }}
                        </div>

                    </div>

                    <div class="payment-page__descr-price">
                        {{ getPriceDuration.value }} х {{ priceThem.coef }} = {{ priceThem.value }} ₽
                    </div>
                    
                </div>
            </div>

            <div class="payment-page__descr-wrapper">

                <div class="payment-page__descr">
                    <div class="payment-page__descr-title">
                        Музыка:

                        <div class="payment-page__descr-subtitle">
                            {{ musics ? 'Использована' : 'Не использована'}}
                        </div>

                    </div>

                    <div class="payment-page__descr-price">
                        {{ priceThem.value }} х {{ musics ? priceMusic.coef : 1 }} = {{ priceMusic.value }} ₽
                    </div>

                </div>

            </div>

            <div class="payment-page__descr-wrapper">
                <div class="payment-page__descr">
                    <div class="payment-page__descr-title">
                        Дата:

                        <div class="payment-page__descr-subtitle">
                            {{ dayStatus }}
                        </div>

                    </div>

                    <div class="payment-page__descr-price"
                        v-if="priceDate.type === 'default'"
                    >
                        {{ priceMusic.value }} х {{ 1 }} = {{ priceMusic.value }} ₽
                    </div>

                    <div class="payment-page__descr-price"
                        v-if="priceDate.type === 'holiday'"
                    >
                        {{ priceMusic.value }} х {{ priceHoliday }} = {{ priceDate.value }} ₽
                    </div>

                    <div class="payment-page__descr-price"
                        v-if="priceDate.type === 'weekend'"
                    >
                        {{ priceMusic.value }} х {{ priceWeekend }} = {{ priceDate.value  }} ₽
                    </div>
                    
                </div>
            </div>


            <div class="payment-page__descr-wrapper">
                <div class="payment-page__descr">
                    <div class="payment-page__descr-title">
                        Время:

                        <div class="payment-page__descr-subtitle">
                            {{ timeStatus }}
                        </div>

                    </div>

                    <div class="payment-page__descr-price"
                    >
                        {{ priceDate.value }} х {{ pricePrimeTime.coef }} = {{ pricePrimeTime.value }} ₽
                    </div>

                </div>
            </div>

          <div class="payment-page__descr-wrapper">
            <div class="payment-page__descr">
              <div class="payment-page__descr-title">
                Съемка:

                <div class="payment-page__descr-subtitle">
                  {{ surveyName }}
                </div>

              </div>

              <div class="payment-page__descr-price"
              >
                {{ surveyPrice }} ₽
              </div>

            </div>
          </div>

            <div class="payment-page__descr-wrapper">
                <div class="payment-page__descr" style="border-bottom: none;">
                    <div class="payment-page__descr-title" style="font-size: 22px; font-family: 'Montserrat-Bold'">
                        Итого:
                    </div>

                    <div class="payment-page__descr-price"
                        :style="{
                            fontFamily: 'Montserrat-Bold',
                            fontSize: '22px'
                        }"
                    >
                        {{ finalPrice}} ₽
                    </div>

                </div>
            </div>

            <div class="payment-page__footer" v-if="rendering">
                <div class="payment-page__condition">
                  <router-link to="/return-policy">Условия возврата</router-link>
                </div>
                <div
                    class="payment-page__button"
                    @click="clickPayment()"
                >
                    <span>Перейти к оплате</span>
                </div>
            </div>

        </div>
        

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="clickLink"
                @clickOutside="clickLink"
            />
        </transition >
        
        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

      <transition
          name="fade-overlay"
          appear
          mode="out-in"
      >

        <app-alert
            v-if="error.status"
            buttonText="Попробовать еще раз"
            :text="error.text"
            @clickGrowButtonPopup="() => {
              error.status = false
              overlay = false
              loading = false
            }"
        />

      </transition>

    </div>
</template>

<script>

    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppAlert = () => import('@/components/popups/error')
    const AppLoading = () => import('@/components/loading.vue')
    const payment = () =>  import("@/views/payment/api")

    export default {
      async mounted() {
        await this.$store.dispatch('price/setPrice')

        this.rendering = true
      },
      components: {
        AppHeader,
        AppMenu,
        AppOverlay,
        AppAlert,
        AppLoading
      },
      data() {
        return {
          overlay: false,
          menu: false,
          rendering: false,
          min: 1,
          loading: false,
          error: {
            status: false,
            text: ''
          }
        }
      },
      computed: {
        day() {
          return this.$store.getters['date/day']
        },
        monthName() {
          return this.$store.getters['date/name']
        },
        selectTime() {
          return this.$store.getters['date/selectTime']
        },
        theme() {
          return this.$store.getters['theme/theme']
        },
        musics() {
          return this.$store.getters['music/music']
        },
        defaultPrice() {
          return this.$store.getters['settings/defaultPrice']
        },
        duration() {
          let num = this.$store.getters['price/restPrice'].duration

          if(num <= 60) {
            let m = Math.trunc(num / 60)

            let s = (num - (m * 60))

            if (s > 0) {
              this.min = m + 1
              return `До ${m + 1} минут(ы)`
            } else {
              this.min = m < 1 ? 1 : m
              return `${m} минута`
            }
          } else {
              let m = Math.trunc(num / 60)
              let s = ( num - (m * 60))
              return `${m} мин. ${s} сек.`
          }
        },
        getPriceDuration() {
          return this.$store.getters['price/restPrice'].price_duration
        },
        dayStatus() {
          if (this.priceDate.type === 'default') {
            return 'Обычный день'
          } else if (this.priceDate.type === 'holiday') {
            return 'Праздничный день'
          } else {
            return 'Выходной день'
          }
        },
        priceHoliday() {
          return this.$store.getters['settings/priceHolidays']
        },
        priceWeekend() {
          return this.$store.getters['settings/priceWeekend']
        },
        primeTime() {
          return this.$store.getters['date/primeTime']
        },
        timeStatus() {
          if (this.primeTime) {
            return 'Прайм-тайм'
          } else {
            return 'Стандартное'
          }
        },
        surveyPrice() {
          return this.$store.getters['price/restPrice'].price_record.price
        },
        surveyName() {
          let info = this.$store.getters['price/restPrice'].price_record
          if (info.type === 'ground') {
            return 'Съёмка с земли'
          } else if (info.type === 'air') {
            return 'Съёмка с воздуха'
          } else if (info.type === 'ground_and_air') {
            return 'Съёмка с земли и с воздуха'
          } else {
            return 'Без съемки'
          }
        },
        priceThem() {
          return this.$store.getters['price/restPrice'].price_them
        },
        priceVideo() {
          return this.$store.getters['price/restPrice'].price_video
        },
        priceMusic() {
          return this.$store.getters['price/restPrice'].price_music
        },
        priceDate() {
          return this.$store.getters['price/restPrice'].price_date
        },
        pricePrimeTime() {
          return this.$store.getters['price/restPrice'].price_time
        },
        price() {
          return this.$store.getters['price/price']
        },
        order() {
          return this.$store.getters['auth/order']
        },
        finalPrice() {
          return this.$store.getters['price/restPrice'].final_price
        },
        bookingTime() {
          return this.$store.getters['settings/reserveTime']
        }
      },
      methods: {
        async clickMenu() {
          this.overlay = true
          this.menu = true
        },
        async clickLink() {
          this.menu = false
          this.overlay = false
        },
        async clickPayment() {
          this.loading = true
          payment().then(data => {
            data.default({
              order: this.order,
              resolve: (data) => {
                this.overlay = false
                this.error.status = false
                this.error.text = ''
                window.location = data.url;
                this.loading = false
              },
              reject: (e) => {
                console.log(e)
                this.overlay = true
                this.error.status = true
                this.error.text = e.error
              }
            })
          })
        }
      }
    }
</script>

<style lang="less">

    .payment-page {
        background-color: #2F1F4C;
        width: 100%;
        min-height: 100vh;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .payment-page__container {
        display: flex;
        flex-direction: column;
        max-width: 500px;
        width: 100%;
        align-items: center;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .payment-page__date {
        color: #FFFFFF;
        font-size: 40px;
        font-family: 'Montserrat-Bold';
        margin-top: 104px;
        display: flex;
        text-align: center;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .payment-page__time-action {
        font-size: 15px;
        color: #978FA5;
        line-height: 20px;
        font-family: 'Roboto-Light';
        margin-top: 13px;
    }

    .payment-page__descr-wrapper {
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .payment-page__descr {
        display: flex;
        align-items: center;
        border-bottom: 0.5px solid rgba(255, 255, 255, 0.3);
        min-height: 50px;
        width: 100%;
        justify-content: space-between;
    }

    .payment-page__descr-title {
        color: #FFFFFF;
        line-height: 20px;
        font-size: 15px;
        font-family: 'Roboto-Light';
        display: flex;
        flex-direction: column;
    }

    .payment-page__descr-subtitle {
        color: #ACAFBE;
        line-height: 20px;
        font-size: 13px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .payment-page__descr-price {
        color: #FFFFFF;
        line-height: 20px;
        font-size: 15px;
        font-family: 'Montserrat-Medium';
        display: flex;
    }

    .payment-page__footer {
        width: 100%;
        bottom: 16px;
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 82px;
        margin-bottom: 16px;

    }

    .payment-page__condition {
        color: #FFFFFF;
        font-size: 15px;
        font-family: 'Roboto-Light';
        border-bottom: 1px dashed #FFFFFF;
        width: 129px;
        margin-bottom: 24px;
        cursor: pointer;
    }

    .payment-page__condition a{
      text-decoration: none;
      color: #FFFFFF;
    }

    .payment-page__button {
        width: 342px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #31283D;
        text-align: center;
        font-size: 16px;
        font-family: 'Montserrat-Medium';
        background: #FFFFFF;
        border-radius: 5px;
        cursor: pointer;
    }
</style>